import React, { useEffect, useState } from "react";
import "../css/Login.css";
import LoginHook from "../hooks/LoginHook";
import loginImg from "../assets/images/logo-22.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import ForgetPasswordHook from "../hooks/ForgetPasswordHook";

const ForgetPassword = () => {
  let {
 
    formData,
    loading,
    handleForgotPassword,
    handleInputChange,
  } = ForgetPasswordHook();

  return (
    <>
      <section className="login">
        <div className="row align-items-center justify-content-center w-100 m-0">
          <div className="col-md-6 d-none d-md-block p-0 ">
            <div className="loginImageContainer">
              <img
                src={loginImg}
                className="loginImg"
                alt="loginImg"
                style={{ width: "50%" }}
              />
            </div>{" "}
          </div>
          <form className="col-12 col-md-6 mb-5" onSubmit={handleForgotPassword}>
            <div className="text-center loginText">
              <h4>Welcome to عالم التقسيط</h4>
            </div>
            <div className="coolinput mx-auto" style={{ position: "relative" }}>
              <label htmlFor="input" className="text">
                Email Address:
              </label>
              <input
                type="email"
                onChange={handleInputChange}
                placeholder="Write here..."
                value={formData.email}
                required
                name="email"
                className="input"
              />
              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "60%",
                  transform: "translateY(-50%)",
                }}
              >
                <FontAwesomeIcon icon={faAt} />
              </span>
            </div>
            <div className="mt-3 forgetPassword">
              <Link to={"/login"} className="text-decoration-none">
                Sign In?
              </Link>
            </div>
        
            <div className="forgetPassword mt-3">
              <button
                type="submit"
                disabled={loading}
                className="btn w-100 loginbtn btn-dark"
              >
                {loading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}{" "}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;
